import { useSelector, useDispatch } from "react-redux";
import { AUTH_ACTIONS } from "../Redux/Reducers/authorization";
import { useNavigate } from "react-router-dom";
import { apis, deleteRequest } from "../Utils/axios";

function useLoginHook() {
	const NAVIGATE = useNavigate();
	const dispatch = useDispatch();
	let authorization = useSelector((state) => state.authorization);

	return {
		...authorization,
		login: () => {
			dispatch({
				type: AUTH_ACTIONS.login,
			});
			localStorage.setItem("authenticated", true);
			NAVIGATE("/blank");
			window.location.href = "/app/home";
		},
		logout: () => {
			deleteRequest(apis.terminateSession, {}, (r, e) => {
				localStorage.removeItem("configuration");
				localStorage.removeItem("authorization");
				localStorage.removeItem("optimize");
				dispatch({ type: AUTH_ACTIONS.logout });
				window.location.href = "/login";
			});
		},
	};
}

export { useLoginHook };
